export default {"src":"/_next/static/media/matterport-flat.e16d7df0.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};